import { render, staticRenderFns } from "./FigurePage.vue?vue&type=template&id=4e1dd8b3&"
import script from "./FigurePage.vue?vue&type=script&lang=js&"
export * from "./FigurePage.vue?vue&type=script&lang=js&"
import style0 from "./FigurePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports